import React from "react";
import { Link } from "react-router-dom";
import { FOOTER_LINKS, LEGAL_VERSION, FINAL_VERSION } from "../legal/legalContent";
import { BrandLogo } from "./BrandLogo";

export const SiteFooter = () => (
  <footer className="border-t border-white/8 bg-[#0C0A0A] text-[#9E978E]" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-2 sm:grid-cols-3 gap-8">
      <div>
        <BrandLogo variant="wordmarkSm" className="h-9 w-auto" />
        <p className="text-xs mt-2 leading-relaxed">An adults-only (18+) dating marketplace. Date Offer amounts are arranged between members and are never held or paid by DateBid.</p>
        <p className="text-[10px] mt-3 text-[#9E978E]">Terms & Refund v{FINAL_VERSION} (pending review) · other policies v{LEGAL_VERSION}</p>
      </div>
      <div>
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#C9A96E] mb-3">Company</div>
        <ul className="space-y-2 text-sm">
          {FOOTER_LINKS.company.map((l) => (
            <li key={l.slug}><Link data-testid={`footer-${l.slug}`} to={l.path || `/legal/${l.slug}`} className="hover:text-[#D4AF37] transition-colors">{l.label}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#C9A96E] mb-3">Legal</div>
        <ul className="space-y-2 text-sm">
          {FOOTER_LINKS.legal.map((l) => (
            <li key={l.slug}><Link data-testid={`footer-${l.slug}`} to={l.path || `/legal/${l.slug}`} className="hover:text-[#D4AF37] transition-colors">{l.label}</Link></li>
          ))}
        </ul>
      </div>
    </div>
  </footer>
);
